import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';

const FAB = () => {
  const navigate = useNavigate();
  return (
    <button
      data-testid="fab-add-cigar-button"
      onClick={() => navigate('/add-cigar')}
      className="fixed bottom-24 right-6 w-14 h-14 rounded-full bg-amber-600 text-white shadow-2xl flex items-center justify-center hover:bg-amber-500 transition-transform hover:scale-110 active:scale-90 z-50"
    >
      <Plus size={28} />
    </button>
  );
};

export default FAB;
